import styled from 'styled-components'

export const ScrollableMessages = styled.div<{ isExpanded?: boolean }>`
  height: 300px;
  flex: 1;
  overflow-y: auto;
  max-height: ${(props) => (props.isExpanded ? '80vh' : '400px')};
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
`
